export const GET_USER_LISTING = "GET_USER_LISTING";
export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const SET_QUERY = "SET_QUERY";
